import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { SopoMenuComponent } from '../../components/sopoMenu/sopo-menu/sopo-menu.component';

@Injectable({
    providedIn: 'root'
})
export class SopoMenuService {
    private _sopoMenuViewContainerRef: ViewContainerRef | undefined;
    private _sopoMenuComponentRef: ComponentRef<SopoMenuComponent> | undefined;

    set sopoMenuViewContainerRef(viewContainerRef: ViewContainerRef) {
        if (this._sopoMenuViewContainerRef) {
            this._sopoMenuViewContainerRef.clear();
            this._sopoMenuComponentRef = undefined;
        }
        this._sopoMenuViewContainerRef = viewContainerRef;
    }

    constructor() { }

    toggleMenu(): void {
        if (!this._sopoMenuViewContainerRef) {
            console.error('Sopo menu view container reference is not set.');
            return;
        }

        if (!this._sopoMenuComponentRef) {
            this._sopoMenuComponentRef = this._sopoMenuViewContainerRef.createComponent(SopoMenuComponent);
            this._sopoMenuComponentRef.instance.close.subscribe(() => {
                this._sopoMenuComponentRef?.destroy();
                this._sopoMenuComponentRef = undefined;
            });
            return;
        }

        this.closeMenu();
    }

    closeMenu(): void {
        if (!this._sopoMenuComponentRef) return;
        this._sopoMenuComponentRef.instance.closeMenu();
    }
}
